import React from 'react';

const JourneyApplicationContext = React.createContext({
  currentAgentIsAssigned: false,
  agentsOptions: null,
  assignedAgentToken: null,
  assignedAgentLabel: null,
  handleChangeAssignedAgent: null,
  handleUnassignAgent: null,
  assignableAgents: null,
  assignedAgent: null,
  assignAgent: null,
  shouldHighlightNodesWithActionRequired: null,
  setShouldHighlightNodesWithActionRequired: null,
});

export default JourneyApplicationContext;
